import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Spinner } from "react-bootstrap";
import ModalCrud from "./UpdateAikikaiModal";

export default function UpdateAikikai() {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const [isLoading, setLoading] = useState(false);
  const [exams, setExams] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [examDetail, setExamDetail] = useState(null);

  const token = JSON.parse(ls.get("jwt"));

  useEffect(() => {
    GetExams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const GetExams = () => {
    setLoading(true);
    var moment = require("moment");

    axios
      .get(
        `${API_URL}/users?populate=exams.grade,exams.dojo.responsible&filters[exams][grade][rank][$eq]=DAN&sort[0]=lastname&sort[1]=name&pagination[pageSize]=1000`,
        headerRequest
      )
      .then((users) => {
        let exams = [];
        for (let i = 0; i < users.data.length; i++) {
          const u = users.data[i];
          if (u.exams?.length) {
            for (let j = 0; j < u.exams.length; j++) {
              const e = u.exams[j];
              if (
                e.grade &&
                e.grade.rank === "DAN" &&
                (e.idAikikai === null || e.idAikikai === "")
              ) {
                let x = {
                  userId: u.id,
                  docNumber: u.docNumber,
                  fullname: u.lastname + ", " + u.name,
                  examId: e.id,
                  date: e.date,
                  gradeId: e.grade.id,
                  grade: e.grade.name,
                  dojo: e.dojo.name,
                  responsible: e.dojo.responsible
                    ? e.dojo.responsible?.lastname +
                      ", " +
                      e.dojo.responsible?.name
                    : "",
                };
                exams.push(x);
              }
            }
          }
        }
        exams.sort(function (a, b) {
          return moment(b.date).toDate() - moment(a.date).toDate();
        });

        setExams(exams);
        setLoading(false);
      });
  };

  const EditExam = (data) => {
    setExamDetail(data);
    setShowModal(true);
  };

  const renderData = (
    <Table striped hover size="sm" responsive="sm" style={{ fontSize: ".8em" }}>
      <thead>
        <tr>
          <th>ID</th>
          <th>DNI</th>
          <th>Nombre</th>
          <th>Fecha</th>
          <th>Graduación</th>
          <th>Dojo</th>
          <th>Responsable</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {exams.length < 1 ? (
          <tr>
            <td colSpan="8" align="center">
              No hay exámenes pendientes de procesar.
            </td>
          </tr>
        ) : (
          exams.map((exam) => (
            <tr key={exam.examId}>
              <td align="center">{exam.userId}</td>
              <td align="center">{exam.docNumber}</td>
              <td align="left">{exam.fullname}</td>
              <td align="center">{exam.date}</td>
              <td align="center">{exam.grade}</td>
              <td align="left">{exam.dojo}</td>
              <td align="left">{exam.responsible}</td>
              <td align="center">
                <Button
                  size="sm"
                  className="btn-xs"
                  onClick={() => EditExam(exam)}
                  variant="warning"
                >
                  Editar
                </Button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <h4>ACTUALIZAR DANES</h4>
      <p>Con los datos Aikikai de la Yudansha</p>
      {isLoading ? <Spinner animation="border" /> : renderData}
      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          className="modal-background"
        ></div>
      )}
      {showModal && (
        <ModalCrud
          show={showModal}
          exam={examDetail}
          onHide={(saved) => {
            setShowModal(false);
            if (saved === true) GetExams();
          }}
        />
      )}
    </Container>
  );
}
